import businessSolutionImage from 'public/images/header/menu-content-photo4.png'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { HeaderNavigationBusiness } from '@/src/domains/header/components/Header/HeaderNavigationBusiness'

export const HeaderNavigationBusinessSolution = () => {
  const { t } = getTranslate()

  return (
    <HeaderNavigationBusiness
      slug="business-solution-menu"
      title={t('component.navigation.businessSolution')}
      image={businessSolutionImage}
    />
  )
}
